import { render, staticRenderFns } from "./EnvironmentBanner.vue?vue&type=template&id=1c8ec4e4&scoped=true"
import script from "./EnvironmentBanner.vue?vue&type=script&lang=js"
export * from "./EnvironmentBanner.vue?vue&type=script&lang=js"
import style0 from "./EnvironmentBanner.vue?vue&type=style&index=0&id=1c8ec4e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8ec4e4",
  null
  
)

export default component.exports